import * as types from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    isFetching: false,
    entity: {}
};

const requestWorkoutsExport = (state) => ({
    ...INITIAL_STATE,
    isFetching: true
});

const receiveWorkoutsExport = (state, action) => ({
    ...state,
    entity: action.data,
    isFetching: false,
    lastUpdated: action.receivedAt
});

const handlers = {
    [types.REQUEST_WORKOUTS_EXPORT]: requestWorkoutsExport,
    [types.RECEIVE_WORKOUTS_EXPORT]: receiveWorkoutsExport
};

export const getWorkoutsExport = (state) => {
    return state.workoutsExport;
};

export default function workoutsExport(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
